import React from 'react';
import AdminNav from '../components/AdminNav';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#05339c]">
      <AdminNav />
      {/* Main content area with padding for sidebar */}
      <main className="lg:mr-64 pt-16 lg:pt-0 min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
